var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[_c('em',[_vm._v("Hint: the testing credentials are 'test_user' and 'test_pass'.")]),_c('hr'),_c('passthrough-form',{attrs:{"endpoint":"/accounts/login/","success-redirect-path":_vm.redirectPath}}),_c('br')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }